import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'App/store';
import { NuvemAppsInstalled } from 'domains/PartnersApps/partnersAppService';
import {
  getNuvemAppsSelector,
  getNuvemApps as getNuvemAppsToDispatch,
} from 'domains/PartnersApps/partnersAppsSlice';

interface UseNuvemAppsResult {
  nuvemApps: NuvemAppsInstalled;
  fetchNuvemApps: () => void;
  isEmpty: boolean;
  isNuvemEnvioInstalled: boolean;
}

function useNuvemApps(): UseNuvemAppsResult {
  const dispatch = useAppDispatch();
  const nuvemApps = useSelector(getNuvemAppsSelector);

  const fetchNuvemApps = useCallback(() => {
    dispatch(getNuvemAppsToDispatch());
  }, [dispatch]);

  const isEmpty = Object.keys(nuvemApps).length === 0;

  const isNuvemEnvioInstalled = Boolean(
    (!!nuvemApps.nuvemenvio && nuvemApps?.nuvemenvio?.installed) ||
      (!!nuvemApps.envionubear && nuvemApps?.envionubear?.installed) ||
      (!!nuvemApps.envionubemx && nuvemApps?.envionubemx?.installed),
  );

  return { isEmpty, nuvemApps, fetchNuvemApps, isNuvemEnvioInstalled };
}

export default useNuvemApps;
